import React from 'react';
import { Button, Col, Dropdown, Icon, Menu, message, Row, Spin, Table, Tag, Tooltip } from 'antd';
import AdvancedForm from './AdvancedForm';
import { invoiceManage, invoiceInput } from 'src/api';
import { history } from 'kts-platform-frame/routes';
import ModulesAction from './Modules.Action';
import { connect } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import { alxd } from 'kts-platform-frame/display/part/InvoiceImport/InvoiceTab/VerifyInvoice';
import {
    transformFinance,
    transformStandard,
    transformInvoiceStatus,
    transformMatchStateEnum,
    transformInvoiceAuthStateEnum,
    transformInvoiceGatherStatus,
    transformRootInvoiceGatherStatus,
    typeDesc
} from 'kts-platform-frame/entry/constant/InvoiceType/EnumInvoiceType';
import PageUi from 'kts-platform-frame/display/components/PageUi';
import ConnectImage from './ConnectImage';
import { JSObject } from 'kts-scaffold-framework/utils/kit';
const css = require('./index.scss');


interface IReduxStatePart {
    companyId?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    refresh: string;
}

/**
 * 模块状态
 */
export class UIListtState {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    companyId: state.user.currentcompanyId
}))
export default class UserForm extends UIBasic<IProps, ModulesState, any> {
    private cursorPointor = {
        cursor: "pointer"
    };
    private columns = [
        {
            title: <span style={{ 'marginLeft': '51px' }}>发票信息</span>,
            dataIndex: "loginName",
            width: 450,
            className: "text-left",
            render: (text, record) => {
                return (
                    <div style={{ whiteSpace: 'nowrap' }} className="special">
                        <div
                            className={"ui-item-icon input-type " +
                                (record.invoiceType ===
                                    "UNKOWN_INVOICE_TYPE"
                                    ? "bg-grey "
                                    : record.standardState === "PASS"
                                        ? "bg-green "
                                        : "bg-red ")
                            }
                        >
                            {typeDesc(record)}
                        </div>
                        <div className="ui-item-description">
                            <div className="ui-item-left-space" title={record.supplierName}>
                                <span className="supplier-name">
                                    {record.supplierName}
                                </span>
                                <span className="log-time">
                                    {
                                        this.forElement(record)
                                    }
                                </span>
                            </div>
                            <div className="ui-item-left-space">
                                <span className="ui-item-info-tertiary">
                                    <span>发票代码 </span>
                                    <span>{record.invoiceCode}</span>
                                </span>
                                <span className="ui-item-info-tertiary">
                                    <span>发票号码 </span>
                                    <span>{record.invoiceNumber}</span>
                                </span>
                                <span className="ui-item-info-tertiary">
                                    <span>开票日期 </span>
                                    <Tooltip title={Field.formatDate(record.invoiceDate)}>
                                        <span>
                                            {Field.formatDate(record.invoiceDate)}
                                        </span>
                                    </Tooltip>
                                </span>
                            </div>
                        </div>
                    </div>
                );
            }
        },
        {
            title: "价税合计",
            width: 150,
            dataIndex: 'amount',
            className: "text-left",
            render: text => {
                return (
                    <span className="ui-item-info-tertiary amount">
                        {text !== null ? ('¥' + Field.formatMoney(text, 2)) : '——'}
                    </span>
                );
            }
        },
        {
            title: "状态",
            width: 280,
            className: "text-left",
            render: (text, record) => {
                return (
                    <div className="ui-item-description">
                        {
                            transformInvoiceStatus(record.invoiceState)
                        }
                        {
                            transformStandard(record.standardState)
                        }
                        {(this.state.pcompanyId) ?
                            transformInvoiceGatherStatus(record.isNotionalpooling)
                            : transformRootInvoiceGatherStatus(record.isNotionalpooling)
                        }
                        {
                            transformFinance(record.financeState)
                        }
                        {
                            transformMatchStateEnum(record.matchState)
                        }
                        {
                            transformInvoiceAuthStateEnum(record.authState)
                        }

                    </div>
                );
            }
        },
        {
            title: "操作",
            width: 200,
            className: "text-right",
            render: (text, record, index) => {
                const menu = (
                    <Menu>
                        <Menu.Item>
                            <div
                                style={this.cursorPointor}
                                onClick={() => {
                                    this.onChangeState(record, index, "PASS");
                                }}
                            >
                                接受
                            </div>
                        </Menu.Item>
                        <Menu.Item>
                            <div
                                style={this.cursorPointor}
                                onClick={() => {
                                    this.onChangeState(record, index, "FAILED");
                                }}
                            >
                                拒绝
                            </div>
                        </Menu.Item>
                    </Menu>
                );
                return (
                    <div>
                        {
                            <div className="ui-item-description">
                                <div className="ui-item-left-space">
                                    <span className="ui-item-info-tertiary">
                                        {(
                                            <span
                                                style={this.cursorPointor}
                                                onClick={() => this.onDetail(record)}
                                            >
                                                详情<span className="vertical-line"> | </span>
                                            </span>
                                        )}
                                        {(
                                            <span style={this.cursorPointor} onClick={() => this.onShowTemplate(record)}>
                                                票面信息<span className="vertical-line"> | </span>
                                            </span>
                                        )}

                                        {(
                                            <Dropdown overlay={menu} placement="topLeft" >
                                                <span style={this.cursorPointor}>
                                                    业务状态
                                                </span>
                                            </Dropdown>
                                        )}
                                        {

                                            (
                                                <span style={this.cursorPointor} onClick={() => this.onConnect(record)} >
                                                    <span className="vertical-line">
                                                        | {record.isUploadFile ? '查看文件' : '关联'}
                                                    </span>
                                                </span>
                                            )}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                );
            }
        }
    ];
    private ford = window.parent.location.href.indexOf('caf') >= 0;
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            list: null,
            image: null,
            expand: false,
            handleSearchIs: !!sessionStorage.getItem("searchHistory"),
            searchTagType: null,
            connect: false,
            connectId: null,
            connectImage: null,
            selectedRowKeys: [],
            selectedRows: [],
            pageSize: 10,
            pageNum: 1,
            fields: null,
            selectTag: null,
            invoiceView: false,
            invoiceType: ""
        };
    }
    forElement = (record) => {
        if (!record.invoiceCode) { return false; }
        let fplx = alxd(record.invoiceCode);//fplx 发票类型 
        if ((fplx === "01" || fplx === "02" || fplx === "03")) {
            if (fplx === "02") {
                return (<span >
                    <Tooltip title={'合计金额 ' + record.amountWithoutTax}>
                        <span>合计金额 </span>
                        <span>{record.amountWithoutTax}</span>
                    </Tooltip>
                </span>);
            } else if (fplx === "03") {
                return (<span>
                    <Tooltip title={'不含税价 ' + record.amountWithoutTax}>
                        <span>不含税价 </span>
                        <span>{record.amountWithoutTax}</span>
                    </Tooltip>
                </span>);
            } else {
                return (<span>
                    <Tooltip title={'开具金额(不含税) ' + record.amountWithoutTax}>
                        <span>开具金额(不含税) </span>
                        <span>{record.amountWithoutTax}</span>
                    </Tooltip>
                </span>);
            }
        } else if (fplx === "04" || fplx === "10" || fplx === "11") {
            return (<span>
                <Tooltip title={'验证码(后六位) ' + (record.invoiceParityCode && record.invoiceParityCode.substr(-6, 6))}>
                    <span>验证码(后六位) </span>
                    <span>{record.invoiceParityCode && record.invoiceParityCode.substr(-6, 6)}</span>
                </Tooltip>
            </span>);

        } else {
            return '';
        }
    }

    toggle = () => {
        const { expand } = this.state;
        if (!expand) {
            this.setState({
                searchTagType: sessionStorage.getItem("searchTagType")
            });
        }
        this.setState({ expand: !expand });
    }
    //纸质发票弹框关闭
    onReceiptClose = () => {
        this.setState({
            detail: null
        });
    }

    closeInvoiceView = () => {
        this.setState({
            invoiceView: false
        });
    }
    onCertificate = record => {
        this.setState({
            image: record.imagePath
        });
    }
    onImageClose = () => {
        this.setState({
            image: null
        });
    }
    //父级触发刷新页面操作
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.refresh !== this.props.refresh) {
            //清空之前的tag搜索记录
            sessionStorage.setItem("searchTagType", "all");
            this.getDataList();
        }
    }
    onChangeState = (record, index, state) => {
        let data = {
            manageId: record.invoiceManageId,
            financeState: state
        };
        const { list } = this.state;
        invoiceManage.changeFinance(this, data).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {

                message.success("操作成功");

                const datalist: any = {};
                Object.keys(list).forEach((item) => {
                    datalist[item] = list[item];

                });
                Object.keys(datalist.items).forEach((childItem) => {
                    if (index + "" === childItem) {
                        datalist.items[childItem].financeState = data.financeState;
                    }
                });
                this.setState({ list: datalist });

            }
        });

    }
    onShowTemplate = record => {
        let data = {
            invoiceManageId: record.invoiceManageId
        };
        invoiceManage.getInvoiceByBizId(this, data).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                //message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        template: true,
                        templateData: res.invoiceDetail,
                        templateType: record.invoiceType
                    });
                }
            }
        });
    }
    //打开查看凭证图片
    onPingzheng = record => {
        this.setState({
            image: record.imagePath
        });
    }
    onDetail =async (record) => {
        const res: any = await invoiceInput.queryManageSingleDetail(this, { invoiceManageId: record.invoiceManageId });
        if (!res.er) {
            history.push({ pathname: `invoiceManage/invoiceDetail/${record.invoiceManageId}`, state: res.res });
        }
        
    }
    componentWillMount() {
        this.getDataList();
    }
    mapListToPage = (page) => {
        this.setState({
            pageNum: page
        }, () => { this.getDataList(null, page); });
    }
    onSizeChange = (current, pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => this.getDataList(null, current));
    }
    getDataList = (type?: string, page?: number) => {

        let data: any = {
            pageNum: page || this.state.pageNum,
            pageSize: this.state.pageSize,
            companyId: sessionStorage.getItem("companyId"),
        };
        if (type) {
            if (type === "all") {
                data.invoiceType = undefined;
            } else if (type === "special") {
                data.invoiceType = "VAT_SPECIAL_INVOICE";
            } else if (type === "normal") {
                data.invoiceType = "VAT_INVOICE";
            } else if (type === "history" && !!sessionStorage.getItem("searchHistory")) {
                var _history = JSON.parse(sessionStorage.getItem("searchHistory"));
                for (var i in _history) {
                    if (i === 'minInvoiceDate' || i === 'maxInvoiceDate' || i === 'minLoggedDate' || i === 'maxLoggedDate') {
                        data[i] = _history[i] && moment(_history[i]);
                    } else {
                        data[i] = _history[i];
                    }
                }
            }
            this.setState({
                fields: { ...this.state.fields, ...data },
                selectTag: type
            });
        }
        //分页请求
        data = {
            ...this.state.fields,
            ...data,
        };
        data = {
            ...data,
            minInvoiceDate:
                data["minInvoiceDate"] &&
                data["minInvoiceDate"].format("YYYY-MM-DD"),
            maxInvoiceDate:
                data["maxInvoiceDate"] &&
                data["maxInvoiceDate"].format("YYYY-MM-DD"),
            minLoggedDate:
                data["minLoggedDate"] &&
                data["minLoggedDate"].format("YYYY-MM-DD"),
            maxLoggedDate:
                data["maxLoggedDate"] &&
                data["maxLoggedDate"].format("YYYY-MM-DD")
        };
        //history.push({ pathname: 'invoiceManage/invoiceList' });

        data = JSObject.getClearBlankParas(data);
        invoiceManage.invoice(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        list: res
                    });
                }
            }
        });
    }
    handleTagToSearch = typeTag => {
        const { expand } = this.state;
        expand ? this.toggle() : null;
        sessionStorage.setItem("searchTagType", typeTag);
        this.getDataList(typeTag);
    }
    handleFormChange = (changedFields) => {
        this.setState({
            fields: { ...this.state.fields, ...changedFields },
        });
    }

    closeTemplate = () => {
        this.setState({
            template: false
        });
    }
    //删除历史筛选
    onFilterClose = () => {
        sessionStorage.setItem('searchHistory', '');
        this.setState({
            handleSearchIs: false,
        }, () => { this.clearFields(); });
    }
    clearFields = () => {
        this.setState({
            fields: null
        });
    }
    //关联弹框
    onConnect = record => {
        this.setState({
            connect: true,
            connectId: record.invoiceManageId,
            connectImage: record.isUploadFile,
            companyId: record.companyId
        });
    }
    //关闭关联弹框
    closeConnect = () => {
        this.setState({
            connect: false
        });
    }
    render() {

        const { selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
        };

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 }
        };
        const { list } = this.state;
        let dataSource = [];
        if (list) {
            dataSource = list.items && list.items.map((item, index) => {
                return {
                    ...item,
                    index
                };
            });
        }
        return (
            <div className="invoiceManage">
                <Row>
                    <Col span={12}>
                        <div className="gutter-box">
                            <label className="mr10">热门标签</label>
                            <span onClick={this.handleTagToSearch.bind(this, "all")}>
                                <Tag
                                    className={this.state.selectTag === 'all' ? 'ant-tag-checkable-checked' : ''}
                                >
                                    全部
                                </Tag>
                            </span>
                            <span onClick={this.handleTagToSearch.bind(this, "special")}>
                                <Tag
                                    className={this.state.selectTag === 'special' ? 'ant-tag-checkable-checked' : ''}
                                >
                                    专票
                                </Tag>
                            </span>
                            <span onClick={this.handleTagToSearch.bind(this, "normal")}>
                                <Tag
                                    className={this.state.selectTag === 'normal' ? 'ant-tag-checkable-checked' : ''}
                                >
                                    普票
                                </Tag>
                            </span>
                            {this.state.handleSearchIs ? (
                                <span onClick={this.handleTagToSearch.bind(this, "history")}>
                                    <Tag
                                        closable={true}
                                        className={this.state.selectTag === 'history' ? 'ant-tag-checkable-checked' : ''}
                                        onClose={this.onFilterClose}
                                    >
                                        上次筛选
                                    </Tag>
                                </span>
                            ) : null}
                            {/* <Tag>电票</Tag> */}
                        </div>
                    </Col>
                    <Col span={12} className="text-right">
                        <Button className="ml-10 mb-10" onClick={this.toggle}>
                            筛选 <Icon type={this.state.expand ? "up" : "down"} />
                        </Button>
                    </Col>
                </Row>
                {this.state.expand ? (
                    <AdvancedForm
                        fields={this.state.fields}
                        onValuesChange={this.handleFormChange}
                        getData={this.getDataList}
                        clearFields={this.clearFields}
                    />
                ) : null}
                <Row>
                    <Spin spinning={!this.state.list}>
                        <Table
                            className="ui-list"
                            rowClassName={() => {
                                return "ui-item doc-item";
                            }}
                            dataSource={dataSource}
                            columns={this.columns}
                            rowKey="index"
                            pagination={false}
                        />
                        {
                            list && <PageUi pageSize={this.state.pageSize} data={list.pageMeta} onChange={this.mapListToPage} onShowSizeChange={this.onSizeChange} />
                        }
                    </Spin>
                </Row>
                {this.state.connect && (
                    <ConnectImage
                        companyId={this.state.companyId}
                        connectId={this.state.connectId}
                        connectImage={this.state.connectImage}
                        closeConnect={this.closeConnect}
                        getDataList={this.getDataList}
                    />
                )}
                {
                    this.state.template &&
                    Template({ type: this.state.templateType, data: this.state.templateData, onClose: this.closeTemplate })
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InvoiceManage/TableList.tsx